/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiAssignCaseRequest,
    InternalApiAssignCaseRequestFromJSON,
    InternalApiAssignCaseRequestToJSON,
    InternalApiCaseAssignment,
    InternalApiCaseAssignmentFromJSON,
    InternalApiCaseAssignmentToJSON,
} from '../models';

export interface AssignCaseRequest {
    handle: string;
    internalApiAssignCaseRequest: InternalApiAssignCaseRequest;
}

export interface UnassignCaseRequest {
    handle: string;
}

/**
 * 
 */
export class CaseAssignmentInternalApi extends runtime.BaseAPI {

    /**
     * Assigns a case to a user
     */
    async assignCaseRaw(requestParameters: AssignCaseRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCaseAssignment>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling assignCase.');
        }

        if (requestParameters.internalApiAssignCaseRequest === null || requestParameters.internalApiAssignCaseRequest === undefined) {
            throw new runtime.RequiredError('internalApiAssignCaseRequest','Required parameter requestParameters.internalApiAssignCaseRequest was null or undefined when calling assignCase.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}/assignment`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiAssignCaseRequestToJSON(requestParameters.internalApiAssignCaseRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCaseAssignmentFromJSON(jsonValue));
    }

    /**
     * Assigns a case to a user
     */
    async assignCase(requestParameters: AssignCaseRequest, initOverrides?: RequestInit): Promise<InternalApiCaseAssignment> {
        const response = await this.assignCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unassigns a case
     */
    async unassignCaseRaw(requestParameters: UnassignCaseRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling unassignCase.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}/assignment`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Unassigns a case
     */
    async unassignCase(requestParameters: UnassignCaseRequest, initOverrides?: RequestInit): Promise<void> {
        await this.unassignCaseRaw(requestParameters, initOverrides);
    }

}
